import type { AssetResponse } from "../generated/api/types.gen";
import { useProjectAssetIds } from "../hooks/useColorPickerModal";
import { ColorAssetPicker } from "./ColorAssetPicker";

interface AssetQuery {
  assets: AssetResponse[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

/** The Assets tab of an asset modal: pick something already saved.
 *
 *  Which assets are on offer is the caller's business (any type, or images
 *  only), so the query is passed in; what is shared is the folder split and
 *  the optional preview affordance. */
export function AssetBrowserTab({
  query,
  projectId,
  enabled,
  selectedAssetId,
  onSelect,
  onPreview,
  emptyMessage,
}: {
  query: AssetQuery;
  projectId?: string | null;
  enabled: boolean;
  selectedAssetId: string | null;
  onSelect: (asset: AssetResponse) => void;
  onPreview?: (asset: AssetResponse) => void;
  emptyMessage: string;
}) {
  const projectAssetIds = useProjectAssetIds(projectId, enabled);

  return (
    <ColorAssetPicker
      assets={query.assets}
      isLoading={query.isLoading}
      isError={query.isError}
      selectedAssetId={selectedAssetId}
      onSelect={onSelect}
      onRetry={query.refetch}
      emptyMessage={emptyMessage}
      // No project means no folder to split on — keep the flat list.
      projectAssetIds={projectId ? projectAssetIds : undefined}
      onPreview={onPreview}
    />
  );
}
